export const checkBookmarkState = (state?: string) =>
  state !== 'NOT_BOOKMARKED';
